const delay = (ms = 1e3) => new Promise((resolve) => {
  setTimeout(() => resolve(), ms);
});
var delay_default = delay;
export {
  delay_default as default
};
